<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <li id="menu-dashboard" class="nav-item">
          <router-link to="/grid" class="nav-link">
            <i class="icon-speedometer"></i> Home
          </router-link>
        </li>
        <li id="menu-dashboard" class="nav-item">
          <router-link to="/dashboard" class="nav-link">
            <i class="icon-speedometer"></i> Dashboard
          </router-link>
        </li>
        <li id="menu-dashboard" class="nav-item">
          <router-link to="/monitoramento" class="nav-link">
            <i class="icon-speedometer"></i> Monitoramento
          </router-link>
        </li>
        <li class="treeview">
          <a class="nav-link nav-dropdown-toggle" href="#" ><i class="icon-note"></i> Jornada</a>
          <ul class="treeview-menu" style="display: none;">
            <li class="nav-item">
              <router-link id="menuCadastrosClientes" to="/analiseJornada" class="nav-link" >
                <i class="icon-note"></i><span class="menu-text">Análise</span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link id="menuCadastrosClientes" to="/gestaoJornada" class="nav-link" >
                <i class="icon-note"></i><span class="menu-text">Gestão Jornada</span>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item">
          <router-link to="/relatorios" class="nav-link">
            <i class="icon-calendar"></i> Relatórios
          </router-link>
        </li>
        <li class="divider"></li>
        
        
        <li class="treeview">
          <a class="nav-link nav-dropdown-toggle" href="#" ><i class="icon-note"></i> Cadastros</a>
          <ul class="treeview-menu" style="display: none;">
            <!-- <li class="nav-item">
              <router-link id="menuCadastrosClientes" to="/clientes" class="nav-link" >
                <i class="icon-note"></i><span class="menu-text">Clientes</span>
              </router-link>
            </li> -->
            <li class="nav-item">
              <router-link to="/motoristas" class="nav-link">
                <i class="icon-calendar"></i> Motoristas
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/veiculos" class="nav-link">
                <i class="icon-calendar"></i> Veículos
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>

// var EventListener = {
//   /**
//    * Listen to DOM events during the bubble phase. (by vue-strap)
//    *
//    * @param {DOMEventTarget} target DOM element to register listener on.
//    * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
//    * @param {function} callback Callback function.
//    * @return {object} Object with a `remove` method.
//    */
//   listen (target, eventType, callback) {
//     if (target.addEventListener) {
//       target.addEventListener(eventType, callback, false)
//       return {
//         remove () {
//           // target.removeEventListener(eventType, callback, false)
//         }
//       }
//     } else if (target.attachEvent) {
//       target.attachEvent('on' + eventType, callback)
//       return {
//         remove () {
//           // target.detachEvent('on' + eventType, callback)
//         }
//       }
//     }
//   }
// }
export default {
  ready () {
    // const dropdowns = document.querySelectorAll('.nav-dropdown > .nav-dropdown-toggle')
    // console.log(dropdowns)
    // if (dropdowns) {
    //   for (var i = 0; i < dropdowns.length; i++) {
    //     dropdowns[i].addEventListener('click', (e) => {
    //       e.preventDefault()
    //       e.target.offsetParent.classList.add('open')
    //     })
    //   }
    // }
    // this._closeEvent = EventListener.listen(window, 'click', (e) => {
    //   if (e.target.classList.contains('nav-dropdown-toggle')) {
    //     return
    //   }
    //   const dropdowns = document.querySelectorAll('.nav-dropdown')
    //   for (let i = 0; i < dropdowns.length; i++) {
    //     dropdowns[i].classList.remove('open')
    //   }
    // })
  },
  beforeDestroy () {
    // if (this._closeEvent) {
    //   this._closeEvent.remove()
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/sidebar.vue